var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-tooltip',{attrs:{"top":_vm.position === 'top',"right":_vm.position === 'right',"bottom":_vm.position === 'bottom',"left":_vm.position === 'left',"activator":_vm.activator}},[_c('span',[_vm._v(_vm._s(_vm.content))])])
}
var staticRenderFns = []

export { render, staticRenderFns }